import { call, put, takeEvery } from 'redux-saga/effects';
// packages
import { ActionType } from 'typesafe-actions';
// modules
import * as Actions from '../actions/findAction';
import { findAPI } from '../apis/findApi';


function* sendForIdSaga(
  action: ActionType<typeof Actions.sendForIdAction.request>
) {
  try{
    const {memberName, hpno} = action.payload;
    
    const res = yield call(findAPI.sendForId, { memberName, hpno });
    yield put(Actions.sendForIdAction.success(res));
  } catch (error) {
    yield put(Actions.sendForIdAction.failure(error));
  }
}

function* findUserIdSaga(
  action: ActionType<typeof Actions.findUserIdAction.request>
) {
  try{
    const {memberName, hpno} = action.payload;

    const res = yield call(findAPI.getUserId, { memberName, hpno });
    yield put(Actions.findUserIdAction.success(res));
  } catch (error) {
    yield put(Actions.findUserIdAction.failure(error));
  }
}

function* sendForPwSaga(
  action: ActionType<typeof Actions.sendForPwAction.request>
) {
  try{
    const {userId, hpno} = action.payload;

    const res = yield call(findAPI.sendForPw, {userId, hpno});
    yield put(Actions.sendForPwAction.success(res));
  } catch (error) {
    yield put(Actions.sendForPwAction.failure(error));
  }
}

function* updatePwSaga(
  action: ActionType<typeof Actions.updatePwAction.request>
) {
  try{
    const {userId, hpno, newPw} = action.payload;

    const res = yield call(findAPI.updatePw, {userId, hpno, newPw});
    yield put(Actions.updatePwAction.success(res));
  } catch (error) {
    yield put(Actions.updatePwAction.failure(error));
  }
}

export function* findSaga() {
  yield takeEvery(Actions.sendForIdAction.request, sendForIdSaga);
  yield takeEvery(Actions.findUserIdAction.request, findUserIdSaga);
  yield takeEvery(Actions.sendForPwAction.request, sendForPwSaga);
  yield takeEvery(Actions.updatePwAction.request, updatePwSaga);
}